export * from './InstanceFactory.Extensions';
import * as instanceFactory from './InstanceFactory.Extensions';

export { instanceFactory };
export default instanceFactory;
